import { Injectable } from '@angular/core';
import { AppService } from '@app/app.service';
import { BackendSystemService } from '@app/portal/services/backend-system.service';
import { Cached, cachedGroup } from '@app/utils/cached';
import { SystemInfoViewModel } from '@business/system/models/system-info-view-model';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SystemService {
  private _systemInfo: Cached<SystemInfoViewModel> | null = null;

  get systemInfo(): Cached<SystemInfoViewModel> {
    this._systemInfo ??= cachedGroup(
      [
        this.appService.branding,
        this.appService.info,
        this.appService.version,
        this.backendSystemService.backendSystems,
        this.backendSystemService.currentBackendSystem,
      ],
      ([branding, info, version, backendSystems, currentBackendSystem]) => {
        return of({
          backendSystems,
          branding,
          currentBackendSystem,
          info,
          version,
        });
      },
      {
        id: 'system:info',
      }
    );

    return this._systemInfo;
  }

  constructor(
    private appService: AppService,
    private backendSystemService: BackendSystemService
  ) {}
}
